var $ = require('jquery');

/**
 *
 * @constructor
 */
var MapRenderer = module.exports = function() {

};

/**
 *
 * @param element
 */
MapRenderer.prototype.decorate = function(element) {
    this.element = (element instanceof $) ? element : $(element);

    this.setData();
    this.initialize();
};

MapRenderer.prototype.setData = function() {
    this.lat = this.element.data('lat');
    this.lng = this.element.data('lng');
    this.href = this.element.data('href');
    this.web = this.element.data('web');
};

MapRenderer.prototype.initialize = function() {
    var location = new google.maps.LatLng(this.lat, this.lng);

    var mapOptions = {
        zoom: 15,
        center: location,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        mapTypeControl: false,
        streetViewControl: false,
        scrollwheel: false
    };
    var theMap = new google.maps.Map(this.element[0], mapOptions);

    if (this.web == 'gmeinder') {
        this.markerUrl = '/sprites/icons/png/marker-gmeinder.png';
    } else {
        this.markerUrl = '/ver/202603231212/sprites/icons/png/marker.png';
    }

    var marker = new google.maps.Marker({
        map: theMap,
        draggable: false,
        position: location,
        visible: true,
        icon: {
            url: this.markerUrl,
            size: new google.maps.Size(43, 60),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(21, 59)
        }
    });

    if (typeof(this.href) != 'undefined') {
        this.setMarkerClickEvent(marker);
    }

    this.map = theMap;
};

/**
 *
 * @param marker {google.maps.Marker}
 */
MapRenderer.prototype.setMarkerClickEvent = function(marker) {
    var t = this;
    google.maps.event.addListener(marker, 'click', function() {
        window.open(t.href,'_blank');
    });
};





// WEBPACK FOOTER //
// ./fe/web-default/src/js/map/renderer.js